import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { WorkspaceResourceLoading, WorkspaceResourceNotAvailable } from '@/shared';
import { useResourceRoutePreview } from '@/shared/components/resource-route-preview/context';
import { useTeamStore } from '@/stores';

import TeamKeyboardShortcutsWrapper from './layout/00-TeamKeyboardShortcutsWrapper';
import Header from './layout/01-Header';
import Tabs from './layout/03-Tabs';
import Content from './layout/04-Content';
import Members from './layout/04-Content/routes/01-Members';
import Metadata from './meta';

const TeamDetail: FC = (): JSX.Element => {
    const preview = useResourceRoutePreview();
    const { teamId } = useParams<{
        teamId: string;
    }>();

    const { selectedTeam: team, loadingTeam: loading, error, fetchTeamById, clearSelectedTeam } = useTeamStore();

    useEffect(() => {
        if (teamId) {
            fetchTeamById(teamId);
        }

        return () => clearSelectedTeam();
    }, [teamId]);

    if (preview && team && team.id === teamId && !loading) {
        return (
            <div style={{ height: '100%', overflowY: 'auto', padding: '1rem' }}>
                <Header team={team} />
                <Members team={team} />
            </div>
        );
    }
    return team?.id && !loading ? (
        <>
            <Metadata name={team?.name} />
            <TeamKeyboardShortcutsWrapper team={team}>
                <Header team={team} />
                {/* <Bookmarks team={team} /> */}
                <Tabs />
                <Content team={team} />
            </TeamKeyboardShortcutsWrapper>
        </>
    ) : loading ? (
        <WorkspaceResourceLoading resourceType='Team' />
    ) : (
        <WorkspaceResourceNotAvailable resourceType='Team' previousRoute='/settings/workspace/permissions/teams' />
    );
};

export default TeamDetail;
